<template>
  <article :class="`card ${theme} margin-bottom-0`">
    <div class="header">
      <font-awesome-icon
        :icon="$v6.solid[avatar]"
        fixed-width
        size="3x"
        class="padding-2xs"
      />
    </div>
    <div class="section text-left">
      <h4>
        <span class="sr-only">Commission</span>
        <template v-if="type === 'icon'">
          {{ iconCount }}
          Icon
          <template v-if="iconCount > 1">s</template>
        </template>
        <template v-else>Your Logo</template>
        <span
          class="float-right"
          :style="`color: var(--fa-dk-${theme});`"
        >
          <span class="sr-only">Cost:</span>
          ${{ formatNumber(cost) }}
        </span>
      </h4>

      <div class="size-sm line-length-xs">
        <p>{{ description }}</p>
        <p v-if="type === 'icon'">Designed in {{ styleCount }} styles in both Font Awesome Classic and Font Awesome Sharp.</p>
        <p v-if="iconCount > 1">${{ formatNumber(costPerIcon) }} per individual icon.</p>
      </div>
    </div>
    <slot name="footer" />
  </article>
</template>
<script>
  import accounting from 'accounting'

  export default {
    name: 'CommissionCard',

    props: {
      avatar: {
        type: String,
        default: 'faSquare'
      },
      cost: {
        type: Number,
        default: 300
      },
      styleCount: {
        type: Number,
        default: 9
      },
      description: {
        type: String
      },
      iconCount: {
        type: Number,
        default: 1
      },
      theme: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'icon'
      }
    },

    computed: {
      totalIconCount() {
        return this.iconCount * (this.classicStyleCount + this.sharpStyleCount)
      },

      costPerIcon() {
        return this.cost / this.iconCount
      }
    },

    methods: {
      formatNumber(number) {
        return accounting.formatNumber(number, { precision: this.precision })
      }
    }
  }
</script>
